// ── ONE RULE FOR WHAT HAPPENED TO AN EMAIL SEND ─────────────────────────────
// Shared by the client timeline (AdminUsers.jsx EmailTimeline) and the
// per-client email list (Admin.jsx), so both say the same thing about the
// same row. Moved here unchanged from AdminUsers.jsx on 2026-09-30.
import { C } from './adminShared';

// ── WHAT HAPPENED TO THE SEND, NEVER ASSUMED ─────────────────────────────────
// Every email_events row used to read "Sent: <time>", whatever became of it.
// The row says more than that, and this reads it (one rule for every email
// type, since they all share this history):
//   event_type 'failed'  — the provider refused it, or accepted it and then
//                          could not send it (Resend's email.failed webhook).
//                          The welcome email (Seq 3) marks a refused attempt
//                          this way (backend services/welcomeEmail.js).
//   event_type 'unknown' — the welcome email's call threw or timed out, so it
//                          MAY have gone; the retry sweep finds out and turns
//                          the row into 'sent' or 'failed'.
//   bounced              — sent, but the receiving server rejected it.
//   complained           — delivered, then marked as spam by the recipient.
// Anything else is a real send. The time shown is the row's created_at —
// for a failed or unknown welcome that is the attempt time, not a send.
export const EMAIL_PROBLEM = {
  failed:     { label: 'Failed',   note: 'not sent — the email provider refused it or could not send it', fg: C.red,   bg: C.redBg },
  unknown:    { label: 'Unknown',  note: 'may not have been sent — the send could not be confirmed', fg: '#7A4A06', bg: C.amberBg },
  bounced:    { label: 'Bounced',  note: 'sent, but the receiving mail server rejected it',           fg: C.red,   bg: C.redBg },
  complained: { label: 'Marked as spam', note: 'delivered, then reported as spam by the recipient',   fg: C.red,   bg: C.redBg },
};
export const emailSendStatus = (e) => {
  if (e.eventType === 'failed')  return 'failed';
  if (e.eventType === 'unknown') return 'unknown';
  if (e.bouncedAt || e.eventType === 'bounced') return 'bounced';
  if (e.eventType === 'complained') return 'complained';
  return 'sent';
};

// The badge's look, one definition for every screen that shows it.
export const problemBadgeStyle = (problem) => ({
  fontSize: 11, fontWeight: 700, color: problem.fg, background: problem.bg,
  border: `1px solid ${problem.fg}55`, borderRadius: 999, padding: '1px 8px',
});

// The email_events row exactly as the API sends it (snake_case) — for screens
// that do not reshape rows first.
export const emailSendStatusOfRow = (row) =>
  emailSendStatus({ eventType: row ? row.event_type : null, bouncedAt: row ? row.bounced_at : null });
